import { Button } from '../buttons/Button';

/**
 * Pie de diálogo estándar: confirmar (primario) + cancelar (secundario).
 * Layout alineado con Headless UI (acción principal a la derecha en desktop).
 */
export const ModalDialogFooter = ({
	cancelButtonRef,
	onCancel,
	onConfirm,
	confirmLabel = 'Confirmar',
	cancelLabel = 'Cancelar',
	loading = false,
	loadingLabel = '',
	confirmVariant = 'primary',
	className = '',
}) => (
	<div className={['px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 gap-4', className].filter(Boolean).join(' ')}>
		<Button type="button" variant={confirmVariant} loading={loading} loadingLabel={loadingLabel} onClick={onConfirm}>
			{confirmLabel}
		</Button>
		<Button
			type="button"
			variant="secondary"
			className="mt-3 sm:mt-0"
			onClick={onCancel}
			ref={cancelButtonRef}
			disabled={loading}
		>
			{cancelLabel}
		</Button>
	</div>
);
